// src/App.tsx
// Root application component.
// Initializes auth state on mount and renders the router.

import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { router } from '@/router'
import { useAuthStore } from '@/stores/authStore'

export function App() {
  const initialize = useAuthStore((s) => s.initialize)

  // Initialize Supabase auth listener on app mount
  useEffect(() => {
    initialize()
  }, [initialize])

  return (
    <>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          duration: 4000,
          style: {
            fontFamily: 'Inter, system-ui, sans-serif',
          },
          classNames: {
            toast: 'shadow-lg border',
            title: 'font-semibold text-sm',
            description: 'text-xs',
          },
        }}
      />
    </>
  )
}
